<template>
  <v-flex xs12 class="text-xs-center" v-if="$store.state.users.loadingUserAuthClasss">
    <v-progress-circular indeterminate :color="$store.state.global.pages[$route.name].color"></v-progress-circular>
  </v-flex>
  <transition name="fadeToggle" mode="out-in" v-else>
    <v-flex xs12>
      <v-card hover>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex class="text-xs-right">
              <v-menu
                bottom
                left
                transition="scale-transition"
                max-height="600px"
                origin="top right"
                :close-on-content-click="false"
                v-model="fieldChooserMenu"
              >
                <v-btn flat icon color="grey" slot="activator">
                  <v-icon>filter_list</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile v-for="header of possibleHeaders" :key="header.value">
                    <v-list-tile-action>
                      <v-checkbox
                        :color="$store.state.global.pages.docket.color"
                        v-model="defaultHeaders"
                        :label="header.text"
                        :value="header.value"
                      ></v-checkbox>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
        <v-data-table :items="userAuthClasses" :headers="headers">
          <template slot="items" slot-scope="props">
            <userAuthClass-row
              :headers="headers"
              :userAuthClassObj="props.item"
              :key="props.item.id"
            ></userAuthClass-row>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </transition>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import UserService from "@/services/requests/userService";
import UserAuthClassRow from "@/components/userAuthClasses/userAuthClassRow";

import UserAuthClassHeaders from "./userAuthClassHeaders";
import HeaderFilters from "@/services/mixins/headerFilters";
//import TableRow from '@/components/ui/masterFileTableRow'
export default {
  mixins: [UserAuthClassHeaders, HeaderFilters],
  data() {
    return {
      fieldChooserMenu: false
    };
  },
  computed: {
    userAuthClasses: Store.getSet({ store: "users", prop: "userAuthClasses" })
  },
  components: {
    UserAuthClassRow
  }
};
</script>

<style scoped>
</style>
